
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
  setPaymentInfo,
  doDismissSubscriptionWarning,
  fetchSubscription
} from '../actions/subscriptions';

import SubscriptionPageComponent from '../components/subscriptions/SubscriptionPage';
import { withSubscription } from './withSubscription';
import { withCurrentUser } from './withUser';

// FIXME put back redirect

const mapDispatchToProps = (dispatch, {subscription}) => {
  return {
    // navigates to payment info page
    handlePaymentInfo: () =>
      dispatch(setPaymentInfo(subscription)),
    dismissSubscriptionWarning: (subscriptionId, warningId) => {
      return dispatch(doDismissSubscriptionWarning(subscriptionId, warningId))
       .then(() => dispatch(fetchSubscription(subscriptionId)))
    }
  }
}

const SubscriptionPage = compose(
  withSubscription,
  withCurrentUser,
  connect(
    undefined,
    mapDispatchToProps
  )
)(
  SubscriptionPageComponent
);

SubscriptionPage.propTypes = {
  subscriptionId: PropTypes.string.isRequired,
};

export default SubscriptionPage;


// WEBPACK FOOTER //
// ./src/containers/SubscriptionPage.js